// extracted by mini-css-extract-plugin
export default {"professionalInfo":"ProfessionalInfo_professionalInfo__jWHh1","Category":"ProfessionalInfo_Category__H+0kf"};